import { Outlet } from 'react-router-dom';
import { Navbar } from 'src/components/navbar';

export function DashboardLayout() {
  return (
    <main className="w-screen h-screen flex flex-col">
      <Navbar />
      <Outlet />
    </main>
  );
}
